/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingunavailabletitle2Inputs */

const en_crosspostingunavailabletitle2 = /** @type {(inputs: Crosspostingunavailabletitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crossposting is coming soon`)
};

const de_crosspostingunavailabletitle2 = /** @type {(inputs: Crosspostingunavailabletitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleichzeitig posten kommt bald`)
};

/**
* | output |
* | --- |
* | "Crossposting is coming soon" |
*
* @param {Crosspostingunavailabletitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingunavailabletitle2 = /** @type {((inputs?: Crosspostingunavailabletitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingunavailabletitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingunavailabletitle2(inputs)
	return de_crosspostingunavailabletitle2(inputs)
});
export { crosspostingunavailabletitle2 as "crosspostingUnavailableTitle" }